import { useParams } from "react-router-dom";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { MarketVerifyAddressPage } from "./MarketVerifyAddressPage";

export const MarketVerifyAddress = () => {
    const { marketId } = useParams();
    const { markets } = useAppSelector((s) => s.work);

    const safeMarketId = marketId ?? "";
    const currentMarket = markets[safeMarketId];

    if (!currentMarket || !!currentMarket?.address?.id) {
        return <NotFound />;
    }

    return <MarketVerifyAddressPage market={currentMarket} />;
};

export default MarketVerifyAddress;
